<main class="px-8 xl:px-0 py-16">

    <section id="sign-up-success" class="container mx-auto max-w-screen-xl prose leading-normal">
        <div class="sign-up-success__intro">
            <h1 class="header-hex-bar"><span class="inline-block">What's Next</span></h1>
        </div>
        <div class="sign-up-success__details flex flex-col-reverse sm:flex-row mt-16">
            <div class="sign-up-success__icon sm:basis-1/4">
                <img src="https://assets.syngentaebiz.com/images/media/ssp-icon-verification-email.svg" alt="Envelope icon" class="mx-auto mt-0">
            </div>
            <div class="sign-up-success__copy sm:basis-3/4" #scrollDiv id="targetDiv">
                <h2 class="text-[36px] mb-8 mt-0">Registration was submitted successfully!</h2>
                <p class="text-[22px] sm:text-[24px] mb-16 sm:mb-0"><em>Check your email to verify your account</em> and you'll be one step closer to earning exciting rewards for sharing your feedback on Storen<sup>&reg;</sup> corn herbicide this season.</p>
            </div>
        </div>
    </section>

</main>